module.exports = __webpack_public_path__ + "assets/img/33_166_big.6ad88cf1.jpg";